import { Col, Progress, Row } from "reactstrap";
import { Badges, H6, Image, LI, P, ProgressBar, UL } from "../../../../AbstractElements";
import { Comment, Done, Issues, Resolved } from "../../../../Constants/Constants";
import { CommonProjectInterFace } from "../../../../Types/ProjectType";
import { dynamicImage } from "../../../../Utils";

export const CommonProjectListCard:React.FC<CommonProjectInterFace> = ({ item }) => {
  return (
    <Col xxl="4" lg="4" md="6">
      <div className={`project-box ${item.progress === 100 ? "b-light1-success" : " b-light1-primary"}`}>
        <Badges color={`${item.badge === "Done" ? "success" : "primary"}`}>{item.badge}</Badges>
        <H6>{item.title}</H6>
        <div className="d-flex">
          <Image className="img-20 me-1 rounded-circle" src={dynamicImage(`user/${item.image}`)} alt="Project" />
          <div className="flex-grow-1">
            <P>{item.sites}</P>
          </div>
        </div>
        <P>{item.description}</P>
        <Row className="details">
          <Col xs="6">
            <span>{Issues} </span>
          </Col>
          <Col xs="6" className={`font-${item.badge === "Done" ? "success" : "primary"}`}>
            {item.issue}
          </Col>
          <Col xs="6">
            <span>{Resolved}</span>
          </Col>
          <Col xs="6" className={`font-${item.badge === "Done" ? "success" : "primary"}`}>
            {item.resolved}
          </Col>
          <Col xs="6">
            <span>{Comment}</span>
          </Col>
          <Col xs="6" className={`font-${item.badge === "Done" ? "success" : "primary"}`}>
            {item.comment}
          </Col>
        </Row>
        <div className="customers">
          <UL className="simple-list flex-row">
            <LI className="d-inline-block">
              <Image className="img-30 rounded-circle" src={dynamicImage(`user/${item.customers_img1}`)} alt="Project" />
            </LI>
            <LI className="d-inline-block">
              <Image className="img-30 rounded-circle" src={dynamicImage(`user/${item.customers_img2}`)} alt="Project" />
            </LI>
            <LI className="d-inline-block">
              <Image className="img-30 rounded-circle" src={dynamicImage(`user/${item.customers_img3}`)} alt="Project" />
            </LI>
            <LI className="d-inline-block ms-2">
              <P className="f-12">{`+${item.like} More`}</P>
            </LI>
          </UL>
        </div>
        <div className="project-status mt-4">
          <div className="d-flex mb-0">
            <P>{item.progress}%</P>
            <div className="flex-grow-1 text-end">{Done}</div>
          </div>
          {item.progress === 100 ? <ProgressBar className="sm-progress-bar" color="success" value={item.progress} animated striped /> : <Progress className="sm-progress-bar" animated striped color="primary" value={item.progress} />}
        </div>
      </div>
    </Col>
  );
};
